<template>
  <div class="p-a-4">
    <card-minimal title="Active" v-if="giveaways.filter(giveaway => ['published', 'closed'].includes(giveaway.state)).length > 0" class="m-b-4">
      <giveaway-item @click.native="open(giveaway)" :giveaway="giveaway" v-for="giveaway in giveaways.filter(giveaway => ['published', 'closed'].includes(giveaway.state))" :key="giveaway.id" />
    </card-minimal>
    <card-minimal title="Not started" v-if="giveaways.filter(giveaway => giveaway.state === 'unpublished').length > 0" class="m-b-4">
      <giveaway-item @click.native="open(giveaway)" :giveaway="giveaway" v-for="giveaway in giveaways.filter(giveaway => giveaway.state === 'unpublished')" :key="giveaway.id" />
    </card-minimal>
    <card-minimal title="Completed" v-if="giveaways.filter(giveaway => giveaway.state === 'completed').length > 0">
      <giveaway-item @click.native="open(giveaway)" :giveaway="giveaway" v-for="giveaway in giveaways.filter(giveaway => giveaway.state === 'completed')" :key="giveaway.id" />
    </card-minimal>
  </div>
</template>

<script>

import GiveawayItem from '@/components/Giveaway/ListItem.vue';

export default {
  components: {
    GiveawayItem,
  },
  computed: {
    /**
     * Get the current list of giveaways in store
     */
    giveaways() {
      return this.$store.getters['Giveaway/giveaways'];
    },
    /**
     * Return the current id of active giveaway, if any.
     * @returns {?String}
     */
    activeGiveaway() {
      return this.$store.getters['Giveaway/active']?.id;
    },
  },
  methods: {
    /**
     * Open a giveaway
     * @param {Object} giveaway
     */
    open(giveaway) {
      // this.$store.commit('Giveaway/setGiveaway', giveaway);
      this.$store.dispatch('Giveaway/getGiveaway', { id: giveaway.id });
    },
  },
};
</script>
